/**

 * Auth V2 — signed-in users on guest-only embeds: open account (no switch-tenant).

 */



import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import { useNavigate } from 'react-router-dom';

import { Card } from '../../../shared/ui/Card.js';

import { Button } from '../../../shared/ui/Button.js';



export interface SignedInAccountPromptCardProps {

  /** Override account destination; default platform `/account`. */

  readonly accountHref?: string;

  readonly onContinue?: () => void;

  readonly onContinueWithoutAccount?: () => void;

}



export function SignedInAccountPromptCard({

  accountHref,

  onContinue,

  onContinueWithoutAccount,

}: SignedInAccountPromptCardProps): JSX.Element {

  const { t } = useTranslation('customer');

  const navigate = useNavigate();

  const homeAccountHref = accountHref ?? '/account';

  const continueHandler = onContinueWithoutAccount ?? onContinue;



  const handleOpenAccount = useCallback(() => {

    navigate(homeAccountHref);

  }, [homeAccountHref, navigate]);



  return (

    <Card padded data-testid="customer-signed-in-account-prompt-card">

      <div className="flex flex-col gap-3">

        <h2 className="text-lg font-semibold">

          {t('auth.signedInPrompt.heading')}

        </h2>

        <p className="text-sm text-[var(--color-on-surface-muted)]">

          {t('auth.signedInPrompt.helper')}

        </p>

        <Button

          intent="primary"

          block

          size="lg"

          data-testid="customer-signed-in-account-prompt-open-account"

          onClick={handleOpenAccount}

        >

          {t('auth.signedInPrompt.openAccount')}

        </Button>

        {continueHandler !== undefined ? (

          <Button

            intent="secondary"

            block

            size="md"

            data-testid="customer-signed-in-account-prompt-continue"

            onClick={continueHandler}

          >

            {t('auth.signedInPrompt.continue')}

          </Button>

        ) : null}

      </div>

    </Card>

  );

}


